<div
  class="modal fade"
  id="sharedConfirmModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sharedConfirmModalLabel"
  aria-hidden="true"
>
  <div role="document" class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ payload.header }}</h4>
        <button class="close">
          <img
            src="./assets/icons/close.svg"
            alt="close-icon"
            (click)="fnCloseModal()"
          />
        </button>
      </div>

      <div class="modal-body position-relative px-0">
        <div class="content p-3 py-0">
          <div *ngIf="payload.isInvalidMessage">
            <p class="blocked-applicant">
              {{ payload.invalidMessage }}
            </p>
          </div>
          <div>
            @if(!payload.isInvalidMessage){
            <div class="form-group">
              <p>{{ payload.body }}</p>
            </div>
            } @if(showRemark){
            <div class="form-group required">
              <label for="remark">Remarks</label>
              <textarea
                id="remark"
                (input)="changeRemarkStatus()"
                (blur)="markAsTouched()"
                [(ngModel)]="remark"
                #remarkModel="ngModel"
                class="form-control mb-0"
                rows="3"
                cols="10"
                [ngClass]="{
                  'is-invalid':
                    (isFormSubmitted || remarkModel.touched) &&
                    this.remark === ''
                }"
                maxlength="250"
              ></textarea>
              <div class="remaining-characters">
                Remaining Characters: {{ 250 - remark.length }}
              </div>
              <div
                *ngIf="
                  (this.isFormSubmitted || this.remarkModel.touched) &&
                  this.remark === ''
                "
                class="remark"
              >
                Please provide a remark
              </div>
            </div>
            }

              <div class="btn-cont" [ngClass]="{'reverse-direction': reverseButton}">
                <button
                  class="btn btn-cancel"
                  type="button"
                  (click)="fnCloseModal()"
                  [ngClass]="payload?.buttonText1?.toLowerCase()"
                >
                  {{ payload.buttonText1 }}
                </button>
                <button
                  class="btn btn-primary"
                  [ngClass]="payload?.buttonText2?.toLowerCase()"
                  type="submit"
                  (click)="fnSubmit()"
                  [disabled]="payload.isInvalidMessage"
                >
                  {{ payload.buttonText2 }}
                </button>
              </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
